import { render, staticRenderFns } from "./virtualInventoryRecords.vue?vue&type=template&id=5e002ac5&scoped=true"
import script from "./virtualInventoryRecords.vue?vue&type=script&lang=js"
export * from "./virtualInventoryRecords.vue?vue&type=script&lang=js"
import style0 from "./virtualInventoryRecords.vue?vue&type=style&index=0&id=5e002ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e002ac5",
  null
  
)

export default component.exports